export default "__VITE_ASSET__taBoKW78__"